import React from 'react';

import artwork from '../../../../Assets/Linkages/SpaceOutreachFilm/The-Tale-Unfolds-Artwork.png';

const TheTaleUnfolds = () => (
  <section
    className="outreach-film-feature outreach-film-feature--grey"
    aria-labelledby="the-tale-unfolds-title"
  >
    <div className="outreach-film-feature-inner outreach-film-feature-inner--reverse">
      <div className="outreach-film-feature-copy">
        <p className="section-eyebrow">BEYOND THE BLUE · THE STORY</p>
        <h2 id="the-tale-unfolds-title">The Tale Unfolds</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          A climate scientist returns to her long-forgotten village, only to discover an ominous
          disaster waiting to unfold. Foreseeing a catastrophic cloudburst, she must act quickly to
          safeguard her community. With time running out, she uses her knowledge, expertise, and
          unshakable resolve to fight an impending crisis. As tensions rise, can she rally those she
          left behind and avert a disaster that could change everything?
        </p>
        <a
          className="outreach-film-trailer-link"
          href="https://www.youtube.com/watch?v=S3IUogINxZ0"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Watch behind the scenes of Jahan Aur Bhi Hain on YouTube"
        >
          Behind the Scenes <span aria-hidden="true">→</span>
        </a>
      </div>

      <figure className="outreach-film-feature-artwork">
        <img src={artwork} alt="The Tale Unfolds artwork for Jahan Aur Bhi Hain" loading="lazy" />
      </figure>
    </div>
  </section>
);

export default TheTaleUnfolds;
